import AppIdb from '../../../data/app-idb';
import CONFIG from '../../../global/config';

const FavoriteHandler = {
  init(surah, btnFavoriteAyah) {
    const favoriteIcon = '<img src="./icons/heart-outline-icon.svg" alt="favorite icon">';
    const unfavoriteIcon = '<img src="./icons/heart-fill-icon.svg" alt="unfavorite icon">';
    this._checkFavoriteStatus({
      btnFavoriteAyah, unfavoriteIcon,
    });
    this._favoriteListener({
      surah, btnFavoriteAyah, favoriteIcon, unfavoriteIcon,
    });
  },

  _favoriteListener({
    surah, btnFavoriteAyah, favoriteIcon, unfavoriteIcon,
  }) {
    btnFavoriteAyah.forEach((btn) => {
      const numAyahQuran = btn.getAttribute('numAyahQuran');
      const numAyahSurah = btn.getAttribute('numAyahSurah');
      const ayahNumber = btn.getAttribute('ayahNumber');
      const surahNumber = btn.getAttribute('surahNumber');
      const surahName = btn.getAttribute('surahName');
      const surahTranslation = btn.getAttribute('surahTranslation');
      const surahRevelation = btn.getAttribute('surahRevelation');
      const tooltipFavoriteAyah = document.querySelector(`#tooltip-favorite-ayah-${numAyahQuran}`);
      const data = surah.data.ayahs[numAyahSurah - 1];
      data.id = Number(numAyahQuran);
      data.ayahNumber = ayahNumber;
      data.surahNumber = surahNumber;
      data.surahName = surahName;
      data.surahTranslation = surahTranslation;
      data.surahRevelation = surahRevelation;
      btn.addEventListener('click', () => this._updateFavoriteStatus({
        btn, favoriteIcon, unfavoriteIcon, numAyahQuran, data, tooltipFavoriteAyah,
      }));
    });
  },

  async _updateFavoriteStatus({
    btn, favoriteIcon, unfavoriteIcon, numAyahQuran, data, tooltipFavoriteAyah,
  }) {
    btn.classList.toggle('active');
    if (btn.classList.contains('active')) {
      btn.innerHTML = unfavoriteIcon;
      await AppIdb.put(CONFIG.OBJECT_STORE_AYAHS, data);
      tooltipFavoriteAyah.classList.remove('invisible');
      setTimeout(() => {
        tooltipFavoriteAyah.classList.add('invisible');
      }, 1500);
    } else {
      btn.innerHTML = favoriteIcon;
      await AppIdb.delete(CONFIG.OBJECT_STORE_AYAHS, Number(numAyahQuran));
    }
  },

  _checkFavoriteStatus({
    btnFavoriteAyah, unfavoriteIcon,
  }) {
    btnFavoriteAyah.forEach(async (btn) => {
      const numAyahQuran = btn.getAttribute('numAyahQuran');
      const ayah = await AppIdb.get(CONFIG.OBJECT_STORE_AYAHS, Number(numAyahQuran));
      if (ayah) {
        btn.classList.toggle('active');
        btn.innerHTML = unfavoriteIcon;
      }
    });
  },
};

export default FavoriteHandler;
